
import { defineComponent } from 'vue'
import teamAbsencesReport from '@/components/calendars/team-absences.vue'
export default defineComponent({
  components: { teamAbsencesReport }
})
